import $ from 'jquery';

export default $.fn.smalsToc = function(options) {
    const defaultOptions = {
        contentElementId: 'toc-content',
        listTag: 'ul',
        listClass: '',
        listItemClass: '',
        linkClass: '',
        headings: 'h2, h3, h4',
        ignoreClass: 'toc-ignore',
        scrollSpy: false
    };
    options = $.extend({}, defaultOptions, options);

    const tocContent = $('#' + options.contentElementId);
    const headingSelectors = options.headings.split(',');
    const headings = $(options.headings, tocContent).not(`.${options.ignoreClass}, .${options.ignoreClass} *`);
    let currentLevel = 0;

    if (headings.length === 0) {
        this.remove();
    }

    if (tocContent.length) {
        const list = $('<' + options.listTag + '>');
        if (options.listClass !== '') {
            list.addClass(options.listClass);
        }
        this.append(list);

        const stack = [list];

        headings.each(function() {
            const heading = $(this);

            const headingText = heading.text();
            const anchor = headingText
                .normalize('NFD')
                .replace(/(&nbsp;)|(<|&lt;)br\s*\/*(>|&gt;)|[^a-zA-Z\d\s’]/g, '')
                .trim()
                .replace(/\s|’/g, '-')
                .toLowerCase();

            // add anchor to title
            heading.attr('id', anchor);

            // create list item
            let item = $('<a>', { href: '#' + anchor, text: headingText.trim() });
            if (options.linkClass !== '') {
                item.addClass(options.linkClass);
            }

            if (options.listTag === 'ul' || options.listTag === 'ol') {
                let listItem = $('<li>');
                if (options.listItemClass !== '') {
                    listItem.addClass(options.listItemClass);
                }
                listItem.append(item);
                item = listItem;

                const level = headingSelectors.findIndex(selector => heading.is(selector));

                if (level > currentLevel) {
                    const parentItem = stack[0].children('li:last')[0];
                    if (parentItem) {
                        const newStackItem = $('<' + options.listTag + '>');
                        if (options.listClass !== '') {
                            newStackItem.addClass(options.listClass);
                        }
                        $(parentItem).append(newStackItem);
                        stack.unshift(newStackItem);
                    }
                } else {
                    stack.splice(0, Math.min(currentLevel - level, Math.max(stack.length - 1, 0)));
                }
                currentLevel = level;
            }
            // Add the list item
            stack[0].append(item);
        });

        if (options.scrollSpy) {
            $(window).on('scroll', function () {
                scrollSpy(headings);
            });
        }
    }
    return this;
}

function scrollSpy(headings) {
    const scrollY = window.scrollY  + 1;
    const offset = 50;

    headings.each(function(index) {
        const headingTop = $(this).offset().top;
        const nextHeading = headings.eq(index + 1);
        const headingBottom = nextHeading.length ? nextHeading.offset().top : $(document).height();
        const isActive = headingTop - offset <= scrollY && headingBottom - offset >= scrollY ;

        $('[href="#'+ this.id +'"]').toggleClass('active', isActive);
    });
}